import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface KpiCardProps {
  label: string;
  value?: string;
  sub?: string;
  critical?: boolean;
  loading?: boolean;
}

/**
 * KPI tile. Fixed padding/type-scale so the empty/skeleton state and the
 * loaded state share the exact same box — no layout shift on data arrival.
 */
export function KpiCard({ label, value, sub, critical, loading }: KpiCardProps) {
  return (
    <Card className="p-[16px]">
      <div className="font-mono text-[9px] font-semibold uppercase tracking-[1.1px] text-s-dim">
        {label}
      </div>
      {loading ? (
        <Skeleton className="mt-[7px] h-[28px] w-[64px]" />
      ) : (
        <div
          className={cn(
            'mt-[7px] font-mono text-[28px] font-bold leading-none',
            critical && 'text-s-bad',
            value === undefined && 'text-s-dim',
          )}
        >
          {value ?? '—'}
        </div>
      )}
      <div className="mt-[3px] min-h-[14px] text-[10.5px] text-s-mid">
        {loading ? '' : (sub ?? '')}
      </div>
    </Card>
  );
}
